import React from 'react'
import { useParams } from 'react-router-dom'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { ScheduleList } from './ScheduleList'

const StudentScheduleList = () => {
	const { studentId } = useParams()

	return (
		<StudentTopMenuLayout activeMenu="Schedule" pageName="Schedule">
			<ScheduleList studentId={studentId} />
		</StudentTopMenuLayout>
	)
}

export { StudentScheduleList }
